<template>
  <Price
    :price="selectedPrice"
    :additional-fee="props.product?.additionalFee ? props.product?.additionalFee : null"
    :is-pricing-simplification="pricingSimplificationExperimentFlag"
    :is-klarna-spacing-enabled="isPDPEnhancementDEnabled && !codeDisabledDividerLinesEnabled"
    :is-word-code-enabled="!codeDisabledDividerLinesEnabled"
    :is-spacing-enabled="isSpacingExperimentEnabled"
    :is-percentage-style-update="codeEnabledPercentageUpdated || codeEnabledPercentageUpdatedMiddlePriceRemoved
      || codeEnabledPercentageUpdatedCopy1 || codeEnabledPercentageUpdatedCopy2"
    :is-middle-price-removed="codeEnabledMiddlePriceRemovedPDP || codeEnabledMiddlePriceRemovedAll || codeEnabledPercentageUpdatedMiddlePriceRemoved"
    :is-product-perks-enabled="isProductPerksEnabled"
    @openDetailsModal="firePromoTag"
  />
</template>

<script setup>
import { Price } from '@common-vue/media-card-large/src/modules/price/components';
import { useProductPrice } from '@modules/price/composables';
import { useExperiments } from '@composables/useExperiments';
import { useKillswitches, useFeatureEligibility } from '@modules/featureControl';
import tagSecondaryPromo from '../../features/analytics/secondaryPromo';
// TODO: rename is-klarna-spacing-enabled prop
const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  product: {
    /** @type import('vue').PropType<Product> */
    type: Object,
    required: true,
  },
});

const selectedPrice = useProductPrice();
const { killswitches } = useKillswitches();

const {
  isPDPEnhancementDEnabled,
} = killswitches;
const { isProductPerksEnabled } = useFeatureEligibility();
const {
  experimentFlags: {
    priceSimplificationEnabled,
    isSpacingExperimentEnabled,
    codeDisabledDividerLinesEnabled,
    codeEnabledDividerLinesDisabled,
    codeEnabledPercentageUpdated,
    codeEnabledMiddlePriceRemovedPDP,
    codeEnabledMiddlePriceRemovedAll,
    codeEnabledPercentageUpdatedMiddlePriceRemoved,
    codeEnabledPercentageUpdatedCopy1,
    codeEnabledPercentageUpdatedCopy2,
  },
} = useExperiments();
// Represent 3 arms for pricingSimplification experiment
const pricingSimplificationExperimentFlag = priceSimplificationEnabled
  || codeDisabledDividerLinesEnabled
  || codeEnabledDividerLinesDisabled
  || codeEnabledPercentageUpdated
  || codeEnabledMiddlePriceRemovedPDP
  || codeEnabledMiddlePriceRemovedAll
  || codeEnabledPercentageUpdatedMiddlePriceRemoved
  || codeEnabledPercentageUpdatedCopy1
  || codeEnabledPercentageUpdatedCopy2;

const firePromoTag = () => {
  tagSecondaryPromo(props.id, selectedPrice.value.offers?.lists?.activeOffers?.length || 0);
};
</script>
